import React, { useEffect } from 'react';
import {Row, Col,Image, Button,} from 'react-bootstrap';
import SSOERROR from '../../../assets/images/ssoerror.png';

const Error = () => {
  useEffect(() => {
      localStorage.removeItem("userDetails");
      localStorage.removeItem("otp");
      localStorage.removeItem("forgetpass");
      localStorage.removeItem("isSSO");
      localStorage.removeItem("URP");
      localStorage.removeItem("store");
      localStorage.removeItem('isSession');
      localStorage.removeItem("isAdmin");
      localStorage.removeItem("userPhotoDetails");
  }, []);
  
    return (
        <>
            <div className="loader-container">
            <Row>
                <Col lg={12}>
                    <div style={styles.authentication}>
                      <Image src={SSOERROR} style={styles.error}/><br/><br/>
                      <h2>404 Page Not Found</h2>
                      <h3>Sorry, an error has occured, Requested page not found!</h3><br/>
                      <h4>Please Contact with Administartor</h4>
                      <br/>
                      <a href="/home"  style={styles.btn1}>    
                          Go to Home
                      </a>
                    </div>
                </Col>
            </Row>
            </div>
        </>
    );
}

const styles: any =
 {
  bg: {backgroundColor:"#ffffff",},
  btn1: {
    backgroundColor: "#e31837",
    height: "48px",
    border: "1px solid",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
    color: "white",
    borderRadius: "0px",
    padding: "15px",
    marginTop:"15px"
  },
   error:{width:"5%",},
   authentication:
   {
     backgroundColor:"#ffffff",
     padding:"40px",
     textAlign:"center",
     marginBottom:"6%",
     marginTop:"12%",

   },
}; 

export default Error;
